document.addEventListener("DOMContentLoaded", function () {
  // Add Validation
  const registrationForm = document.querySelector('.warranty_form_inner');
  const fields = registrationForm.querySelectorAll('input,select,textarea');
  const warrantySend = document.querySelector('#warrentysendButton');
  const warranty_form_state = document.querySelector('.warranty_form_inner'); 
  const purchaseProductField = document.querySelector('#purchaseProductField');
  
  fields.forEach(field => {
      field.addEventListener('blur', validateField);
  });

  function validateField(event) {
    const field = event.target;
    const errorSpan = field.closest('.field').querySelector('.form-err-msg');
    var errorMessage = '';
    switch (field.name) {
        case 'contact[Full Name]':
            if (!/^[A-Za-z\s]+$/.test(field.value)) {
                errorMessage = 'Name must only contain alphabetic characters';
            } else if (field.value.trim() === '') {
                errorMessage = 'Name is required';
            }
            break;
        case 'contact[Phone number]':
            if (field.value.trim() === '') {
                errorMessage = 'Phone number is required';
            }
            else if (!/^\d{10}$/.test(field.value)) {
                errorMessage = 'Phone number must be 10 digits';
            }
            break;
        case 'contact[email]':
           if (field.value.trim() === '') {
              errorMessage = 'Email field is required';
          } else if (!/^[^\s@;{}"]+@[^\s@;{}"]+\.[^\s@;{}"]{2,}$/.test(field.value)) {
              errorMessage = 'Invalid email address.';
          }
            break;
        case 'contact[productType]':
          if (field.value === '') {
              errorMessage = 'Please select a product type';
          }
          break;
        case 'contact[product]':
          if (field.value.trim() === '') {
              errorMessage = 'Please select a model';
          }
          break;
        case 'contact[productissue]':
          if (field.value.trim() === '') {
              errorMessage = 'Please select an issue you are facing with your Smartwatch';
          }
          break;
        case 'contact[elaborateissue]':
            if (field.value.trim() === '') {
                errorMessage = 'Elaborate field is required';
            }
            break;
        case 'contact[wheretopurchase]':
          if (field.value.trim() === '') {
              errorMessage = 'Please select where you purchased the product from';
          }
          break;
        case 'contact[date]':
            if (field.value.trim() === '') {
                errorMessage = 'Date field is required';
            }
            break;
        case 'contact[frontimage]':
            if (field.files.length === 0) {
                errorMessage = 'Please upload the front image of the product';
            }
            break;
        case 'contact[backimage]':
            if (field.files.length === 0) {
                errorMessage = 'Please upload the back image of the product';
            }
            break;
        case 'contact[invoice]':
            if (field.files.length === 0) {
                errorMessage = 'Please upload the invoice of your purchase';
            }
            break;
        case 'contact[address]':
            if (field.value.trim() === '') {
                errorMessage = 'Please provide the address(including City,State) to pick up the defective product';
            }
            break;
        case 'contact[pincode]':
          if (field.value.trim() === '') {
            errorMessage = 'Please enter your pincode';
          }
          else if (!/^\d{5,}$/.test(field.value)) {
              errorMessage = 'Please enter valid pincode';
          }
          break;
        default:
            console.log('Default case');
            break;
    }

    if (errorSpan) {
      errorSpan.textContent = errorMessage;
      errorSpan.style.display = 'block';
    }
  }

 const productTypeSelect = document.querySelector('#productType');
 const productSelect = document.querySelector('#productSelect');
 const modelPop = document.getElementById('WrtModelPop');
 const modelList = document.getElementById('WrtModelList');
 const modelSearch = document.getElementById('WrtModelSearch');
 const modelNote = document.getElementById('WrtModelNote');
 const modelAdd = document.getElementById('WrtModelAdd');
 let modelApiUrl = 'https://app.pebblecart.com/Notifyme/public/getProductsByType';
 try {
   const savedUrl = (JSON.parse(document.getElementById('WrtModelApi').textContent).url || '').trim();
   if (savedUrl) modelApiUrl = savedUrl;
 } catch (error) {}
 const modelCache = {};
 let modelProducts = [];
 let modelChosen = {};

 function modelItems(payload) {
   const products = payload && Array.isArray(payload.data) ? payload.data : [];
   const rows = [];
   products.forEach(function (item) {
     const title = item.title || '';
     const image = typeof item.image === 'string' ? item.image : '';
     const variants = Array.isArray(item.variants) && item.variants.length ? item.variants : [null];
     variants.forEach(function (variant) {
       const variantTitle = variant && variant.title ? String(variant.title) : 'Default';
       const sku = variant && variant.sku ? String(variant.sku) : '';
       rows.push({
         id: String((variant && variant.variantId) || item.productId || title + '-' + variantTitle),
         title: String(title),
         variant: variantTitle,
         sku: sku,
         price: variant && variant.price != null ? String(variant.price) : '',
         image: image,
         label: title + (variantTitle ? ' - ' + variantTitle : '')
       });
     });
   });
   return rows.filter(function (row) { return row.title; });
 }

 function moneyLabel(value) {
   if (value === '') return '';
   const number = Number(String(value).replace(/[^0-9.]/g, ''));
   if (!number && number !== 0) return value;
   return '₹' + number.toLocaleString('en-IN');
 }

 function closeModelPop() {
   if (!modelPop) return;
   modelPop.hidden = true;
   document.documentElement.style.overflow = '';
 }

 function openModelPop() {
   if (!modelPop) return;
   modelPop.hidden = false;
   document.documentElement.style.overflow = 'hidden';
   if (modelSearch) modelSearch.focus();
 }

 function paintModels(query) {
   const needle = (query || '').trim().toLowerCase();
   const rows = modelProducts.filter(function (product) {
     if (!needle) return true;
     return (product.title + ' ' + product.variant + ' ' + product.sku).toLowerCase().indexOf(needle) !== -1;
   });
   modelList.innerHTML = '';
   if (!rows.length) {
     modelList.innerHTML = '<p class="wrt-model-pop__empty">No products found.</p>';
     return;
   }
   rows.forEach(function (product) {
     const row = document.createElement('label');
     row.className = 'wrt-model-pop__row';
     const box = document.createElement('input');
     box.type = 'checkbox';
     box.checked = !!modelChosen[product.id];
     box.addEventListener('change', function () {
       if (box.checked) modelChosen[product.id] = product;
       else delete modelChosen[product.id];
     });
     const img = document.createElement('span');
     img.className = 'wrt-model-pop__thumb';
     if (product.image) {
       const picture = document.createElement('img');
       picture.src = product.image;
       picture.alt = '';
       img.appendChild(picture);
     }
     const copy = document.createElement('span');
     copy.className = 'wrt-model-pop__copy';
     copy.innerHTML = '<strong></strong><span class="wrt-model-pop__variant"></span><span class="wrt-model-pop__stock"></span>';
     copy.querySelector('strong').textContent = product.title;
     copy.querySelector('.wrt-model-pop__variant').textContent = product.variant;
     const stock = copy.querySelector('.wrt-model-pop__stock');
     stock.textContent = product.sku;
     stock.classList.toggle('is-out', !product.sku);
     const price = document.createElement('span');
     price.className = 'wrt-model-pop__price';
     price.textContent = moneyLabel(product.price);
     row.appendChild(box);
     row.appendChild(img);
     row.appendChild(copy);
     row.appendChild(price);
     modelList.appendChild(row);
   });
 }

 function applyModels() {
   const picked = Object.keys(modelChosen).map(function (id) { return modelChosen[id]; });
   if (!picked.length) {
     modelNote.hidden = false;
     modelNote.textContent = 'Select at least one product.';
     return;
   }
   const names = picked.map(function (product) { return product.label || product.title; }).filter(Boolean);
   productSelect.innerHTML = '<option value="" disabled>Select Model</option>';
   const option = document.createElement('option');
   option.value = names.join(', ');
   option.textContent = option.value;
   option.selected = true;
   productSelect.appendChild(option);
   productSelect.value = option.value;
   closeModelPop();
 }

 function loadModels(type) {
   modelNote.hidden = true;
   modelList.innerHTML = '<p class="wrt-model-pop__empty">Loading products…</p>';
   openModelPop();
   const cached = modelCache[type];
   if (cached) {
     modelProducts = cached;
     paintModels(modelSearch.value);
     return;
   }
   const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
   fetch(modelApiUrl, {
     method: 'POST',
     headers: headers,
     body: JSON.stringify({ product_type: type })
   })
     .then(function (response) {
       if (!response.ok) throw new Error('Could not load products.');
       return response.json();
     })
     .then(function (payload) {
       if (payload && payload.status && payload.status !== 'success') throw new Error('Could not load products.');
       modelProducts = modelItems(payload);
       modelCache[type] = modelProducts;
       paintModels(modelSearch.value);
     })
     .catch(function () {
       modelProducts = [];
       modelList.innerHTML = '<p class="wrt-model-pop__empty">Could not load products. Please try again.</p>';
     });
 }

 productTypeSelect.addEventListener('change', function () {
   const selectedType = productTypeSelect.value;
   if (modelApiUrl) {
     modelChosen = {};
     productSelect.value = '';
     if (!selectedType) {
       closeModelPop();
       return;
     }
     if (modelSearch) modelSearch.value = '';
     loadModels(selectedType);
     return;
   }
   const optgroups = productSelect.querySelectorAll('optgroup');
   optgroups.forEach(function (optgroup) {
     optgroup.style.display = optgroup.getAttribute('data-collection') === selectedType ? 'block' : 'none';
   });
   productSelect.value = '';
 });

 if (modelApiUrl) {
   productSelect.addEventListener('mousedown', function (event) {
     event.preventDefault();
     if (productTypeSelect.value) loadModels(productTypeSelect.value);
   });
   modelSearch.addEventListener('input', function () {
     paintModels(modelSearch.value);
   });
   modelAdd.addEventListener('click', applyModels);
   modelPop.addEventListener('click', function (event) {
     if (event.target.closest('[data-wrt-model-close]')) closeModelPop();
   });
   document.addEventListener('keydown', function (event) {
     if (event.key === 'Escape' && modelPop && !modelPop.hidden) closeModelPop();
   });
 }

 productTypeSelect.dispatchEvent(new Event('change'));

  function previewImage(inputId, imgPreviewId) {
    document.querySelector(inputId).addEventListener('change', function(event) {
      const file = event.target.files[0];
      const imgElement = document.querySelector(imgPreviewId);
      
      if (file && file.type.startsWith('image')) {
        const reader = new FileReader();
        reader.onload = function(e) {
          imgElement.src = e.target.result;
          imgElement.style.display = 'block';
        };
        reader.readAsDataURL(file);
      } else {
        imgElement.style.display = 'none';
      }
    });
  }
  previewImage('#invoice', '#invoicePreview');

  // Add field name 
  const collectionname = document.querySelector('[name="contact[productType]"]');
  collectionname.addEventListener('change', (event) => {
    const selectedOptionText = event.target.selectedOptions[0].text;
    var name = document.querySelectorAll(".selectedname");
    name.forEach(filedname => {
      filedname.innerHTML = selectedOptionText;
    });
  });

  warrantySend.addEventListener('click', function (event) {
    event.preventDefault();
  
    const form = document.getElementById('ContactForm-warrantyForm'); // Ensure the correct form ID is used
  
    // Get the form field values
    const username = warranty_form_state.querySelector('[name="contact[Full Name]"]').value,
      mobile_number = warranty_form_state.querySelector('[name="contact[Phone number]"]').value,
      email = warranty_form_state.querySelector('[name="contact[email]"]').value,
      categoryName = warranty_form_state.querySelector('[name="contact[productType]"]').value || "null",
      whereToPurchase = warranty_form_state.querySelector('[name="contact[wheretopurchase]"]').value || "null",
      date = warranty_form_state.querySelector('[name="contact[date]"]').value || "null",
      invoice = warranty_form_state.querySelector('[name="contact[invoice]"]').files[0] || "null", // Get the file object
      state = warranty_form_state.querySelector('[name="contact[state]"]').value,
      city = warranty_form_state.querySelector('[name="contact[city]"]').value,
      pincode = warranty_form_state.querySelector('[name="contact[pincode]"]').value,
      model = warranty_form_state.querySelector('[name="contact[product]"]').value,
      company_gift = warranty_form_state.querySelector('[name="contact[giftDetails]"]').value || "null";
     
  
    // Validation checks
    if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '' || categoryName === '' || pincode === '') {
      alert('Please fill out all fields');
      return false;
    }
  
    const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
    if (!emailPattern.test(email)) {
      alert('Please enter a valid email address');
      return false;
    }
  
    const mobilePattern = /^\d{10}$/;
    if (!mobilePattern.test(mobile_number)) {
      alert('Please enter a valid 10-digit mobile number');
      return false;
    }
  
    const pincodePattern = /^\d{5,}$/;
    if (!pincodePattern.test(pincode)) {
      alert('Please enter a valid pincode');
      return false;
    }
  
    if (purchaseProductField.style.display == 'block') {
      if (!invoice) {
        alert('Please add invoice image');
        return false;
      }
    }
  
    warrantySend.classList.add('loading');
  
    console.log('invoice');
    console.log(invoice);
    
    // Convert invoice file to Base64
    if (invoice instanceof Blob) {
      const reader = new FileReader();
      reader.readAsDataURL(invoice);
      reader.onload = function () {
        const base64Invoice = reader.result;
  
        // Construct the JSON payload with base64 encoded invoice
        const payload = {
          name: username,
          mobile: mobile_number,
          email: email,
          product_type: categoryName,
          model: model,
          purchased_from: whereToPurchase,
          date_of_purchase: date,
          state: state,
          city: city,
          pincode: pincode,
          invoice: base64Invoice, // Include the base64 invoice as a parameter
          company_gift: company_gift,
        };
  
        // Send the data using Fetch API
        fetch('https://app.pebblecart.com/ShiprocketETAWidget/public/getDataFromUsersForCpanel', {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${window.sessionToken}`
          },
          body: JSON.stringify(payload)
        })
          .then(res => {
            if (res.ok) {
              return res.json();
            } else {
              throw new Error('Error submitting the form data');
            }
          })
          .then(data => {
            warrantySend.classList.remove('loading');
            document.querySelector('.wrt-tankyou-pop').classList.add('active');
            document.querySelector('.tankyou-container').classList.add('active');
            form.reset();
  
            var images = form.getElementsByTagName('img');
            for (var j = 0; j < images.length; j++) {
              images[j].style.display = 'none';
            }
          })
          .catch(error => {
            warrantySend.classList.remove('loading');
            document.querySelector('.wrt-error-pop').classList.add('active');
            console.error('Error:', error);
          });
      };
    } else {
      // If no invoice file, proceed without the file field
      const payload = {
        name: username,
        mobile: mobile_number,
        email: email,
        product_type: categoryName,
        model: model,
        purchased_from: whereToPurchase,
        date_of_purchase: date,
        state: state,
        city: city,
        invoice: "noInvoce", // Include the base64 invoice as a parameter
        pincode: pincode,
        company_gift: company_gift,
      };
  
      // Send the data using Fetch API
      fetch('https://app.pebblecart.com/ShiprocketETAWidget/public/getDataFromUsersForCpanel', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${window.sessionToken}`
        },
        body: JSON.stringify(payload)
      })
        .then(res => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error('Error submitting the form data');
          }
        })
        .then(data => {
          warrantySend.classList.remove('loading');
          document.querySelector('.wrt-tankyou-pop').classList.add('active');
          document.querySelector('.tankyou-container').classList.add('active');
          form.reset();
  
          var images = form.getElementsByTagName('img');
          for (var j = 0; j < images.length; j++) {
            images[j].style.display = 'none';
          }
        })
        .catch(error => {
          warrantySend.classList.remove('loading');
          document.querySelector('.wrt-error-pop').classList.add('active');
          console.error('Error:', error);
        });
    }
  });
  

  document.querySelector('.tankyou-container-close').addEventListener('click', function() {
    document.querySelector('.wrt-tankyou-pop').classList.remove('active');
    document.querySelector('.tankyou-container').classList.remove('active');
    document.querySelector('.wrt-error-pop').classList.remove('active');
  });
});